import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import {
  ResourceDto,
  resourceInit,
  resourcesValidationSchema,
} from '../resources.dtos';
import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import { Prompt } from 'react-router';
import CancelSaveBtns from '../../../../../../common/components/buttons/cancelSaveBtns';
import DeleteBtn from '../../../../../../common/components/buttons/deleteBtn';
import ResourceCreateForm from './resourceCreateForm';
import ResourceUpdateForm from './resourceUpdateForm';

interface IProps {
  open: boolean;
  onSave: (resource: ResourceDto) => void;
  onClose: () => void;
  values: ResourceDto;
  openDeleteDialog: () => void;
}

const ResourceDialog: React.FC<IProps> = ({
  open,
  onSave,
  onClose,
  values,
  openDeleteDialog,
}) => {
  const [dto, setDto] = useState<ResourceDto>(resourceInit);

  useEffect(() => {
    setDto(JSON.parse(JSON.stringify(values)));
  }, [values]);

  return (
    <Formik
      initialValues={dto}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={resourcesValidationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);

          onSave({ ...values });
        }, 700);
      }}
      enableReinitialize={true}
    >
      {(props) => {
        const {
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
        } = props;
        return (
          <>
            <Dialog open={true} fullWidth>
              <DialogTitle>Facility URLs</DialogTitle>
              <DialogContent>
                <form onSubmit={handleSubmit} noValidate>
                  {values.id === '' ? (
                    <ResourceCreateForm
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                    />
                  ) : (
                    <ResourceUpdateForm
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                    />
                  )}

                  <Grid container justify='flex-end'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name='isActive'
                          color='primary'
                          onClick={() =>
                            setFieldValue('isActive', !values.isActive)
                          }
                          size='small'
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.isActive || true}
                          checked={values.isActive}
                        />
                      }
                      label='Active'
                    />
                  </Grid>
                  <Grid
                    container
                    justify={values.id ? 'space-between' : 'flex-end'}
                  >
                    {values.id ? (
                      <DeleteBtn
                        onClick={() => {
                          openDeleteDialog();
                        }}
                      />
                    ) : null}
                    <CancelSaveBtns
                      isSubmitting={isSubmitting}
                      onClose={onClose}
                      saveText='Save'
                      open={open}
                    />
                  </Grid>
                </form>
              </DialogContent>
              <Prompt message='You have unsaved edits, are you sure you want to leave?' />
            </Dialog>
          </>
        );
      }}
    </Formik>
  );
};

export default ResourceDialog;
